import React, {FormEvent, useContext, useState} from 'react';
import {
    PDFDownloadLink,
    Document,
    Page,
    Text,
    View,
    Image,
    Font
} from '@react-pdf/renderer';
import {ConfigContext, CurrentContext, lengthToType, SetterContext} from "../App";
import {encode as b64encode} from "base-64";
import emailjs from "emailjs-com";
import {Simulate} from "react-dom/test-utils";
import submit = Simulate.submit;

interface FormData {
    first_name: string;
    last_name: string;
    email: string;
    tel: string;
}


function Pdf() {
    const config = useContext(ConfigContext);
    const current = useContext(CurrentContext);
    const currentString = JSON.stringify(current);
    const Setter = useContext(SetterContext);

    // console.log(current.package)

    //download button
    const [isDisabled, setIsDisabled] = useState(true);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, setFormData: React.Dispatch<React.SetStateAction<FormData>>) => {
        const {name, value} = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };


    const saveData = (e: React.FormEvent<HTMLFormElement>, formData: FormData, url: string) => {
        e.preventDefault();

        const templateParams = {
            first_name: formData.first_name,
            last_name: formData.last_name,
            email: formData.email,
            tel: formData.tel,
            link: url
        };


        emailjs.send('service_zxyhhfe', 'template_4432ktr', templateParams, 'z-mYqXhGB3QQ_H6Pq')
                .then((response) => {
                    alert('Wir haben deine E-Mail erhalten und melden uns in Kürze bei dir! Dein persönliches Angebot steht dir jetzt zum Download bereit');
                    setIsDisabled(false);


                }, (error) => {
                    alert('Huch, irgendetwas hat nicht funktioniert. Versuche es bitte erneut.');
                });
    };


    const pdf_download = () => {
        setFormData((prevData) => ({
            ...prevData,
            email: '',
            tel: ''
        }));
        // deactivate button after download
        setIsDisabled(true);
    }

    const [formData, setFormData] = useState<FormData>({
        first_name: '',
        last_name: '',
        email: '',
        tel: '',
    });

    function getPrice() {

        let price = 0;

        const lengthType = lengthToType(current.length);
        const innerVersion = config.inside.versions.find(v => v.name === current.inside_version)!;

        if (current.seats < innerVersion.includedSeats) {
            Setter("seats")(String(innerVersion.includedSeats));
        }

        price += config.seats.price * (current.seats - innerVersion.includedSeats);

        const outsideConfig = config.car.car
                .find(c =>
                        c.length === current.length
                        && c.engine === current.engine
                        && c.transmission === current.transmission,
                )!;
        price += outsideConfig.price;

        price += config.carPackage.find(p => p.package === current.package)!.price;
        price += config.carColorOutside.find(c => c.name === current.outside_color)!.price;
        price += config.inside.versions.find(
                p =>
                        p.name === current.inside_version
                        && p.typ === lengthType,
        )!.price;
        price += config.tech.techPackage.find(t => t.name === current.tech_package)!.price;

        price += current.tech_optional
                .map((o: string) =>
                        config.tech
                                .techOptional
                                .find(t => t.name === o))
                .reduce(
                        (acc: number, elem: any) => acc + elem.price,
                        0,
                );

        price += current.gadgets
                .map((o: string) =>
                        config.Gagets
                                .find(t => t.name === o))
                .reduce(
                        (acc: number, elem: any) => acc + (
                                current[`amount-${elem.name}`] === undefined
                                        ? elem.price
                                        : elem.price * Number.parseInt(current[`amount-${elem.name}`])

                        ),
                        0,
                );

        if (current.inside_version === "Basic Camper") {
            price += current.modules
                    .map((o: string) =>
                            config.modules
                                    .find(t => t.name === o))
                    .reduce(
                            (acc: number, elem: any) => acc + (typeof elem.price === "number" ? elem.price : (
                                    current.length === "5,40m" ? elem.price.l2h2 : elem.price.l3h2
                            )),
                            0,
                    );
        }

        return Math.round(price * 1.19).toLocaleString("de")

    }

    const yourPrice = getPrice()

    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "/" + month + "/" + year;

    // console.log(currentDate);

    const type_desc = config.car.car
            .find(c =>
                    c.length === current.length
                    && c.engine === current.engine
                    && c.transmission === current.transmission,
            )!;

    const outerColor = config.carColorOutside.find(c => c.name === current.outside_color)!;
    const innerColor = config.colorInside.find(c => c.fabricColorName === current.inside_color)!;
    const innerVersion = config.inside.versions.find(c => c.name === current.inside_version)!;
    const techPackage = config.tech.techPackage.find(c => c.name === current.tech_package)!;
    const lengthType = lengthToType(current.length);
    const currentInsideVersion = config.inside.versions.find(
            p =>
                    p.name === current.inside_version
                    && p.typ === lengthType)!;

    // console.log(currentInsideVersion)


    const currentEncoded = b64encode(currentString);

    // const url = new URL(window.location.href);
    const url = new URL("http://konfigurator.intern.321.vanchanger.de/konfigurator/index.html")
    url.searchParams.set("config", currentEncoded);

    // console.log(url.href);

    Font.register({
        family: 'Inter',
        fonts: [
            {src: window.location.origin + '/konfigurator/font/inter_var.ttf'},
            {src: window.location.origin + '/konfigurator/font/inter_bold.ttf', fontWeight: 600},
            {src: window.location.origin + '/konfigurator/font/inter_extraBold.ttf', fontWeight: 800}
        ]
    });

    const outsideConfig = config.car.car
            .filter(c => c.length === current.length)
            .filter(c => c.engine === current.engine)
            .filter(c => c.transmission === current.transmission)[0];

    const carPackage = config.carPackage.filter(c => c.package === current.package)!;
    // const insideVersion = config.inside.versions.find(c => c.version === current.inside_version)!;

    const MyDocument = () => (
            <Document>
                <Page size="A4" style={{position: 'relative'}}>

                    <Text style={{
                        fontFamily: 'Inter',
                        fontWeight: 800,
                        position: 'absolute',
                        top: '78%',
                        fontSize: '12px',
                        color: '#3A536B',
                        paddingLeft: '63px'
                    }}>{`${type_desc.typ_desc} - ${current.outside_color}`}</Text>
                    <Text style={{
                        position: 'absolute',
                        top: '80.5%',
                        fontSize: '12px',
                        color: '#3A536B',
                        paddingLeft: '63px'
                    }}>{`${current.engine} ${current.transmission} | ${current.package}`}</Text>
                    <Text style={{
                        position: 'absolute',
                        top: '82.5%',
                        fontSize: '12px',
                        color: '#3A536B',
                        paddingLeft: '63px'
                    }}>{`${current.inside_version} | ${current.tech_package}`}</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        fontWeight: 600,
                        position: 'absolute',
                        top: '500px',
                        fontSize: '35px',
                        color: '#3A536B',
                        paddingLeft: '63px'
                    }}>{`${formData.first_name}`}</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '540px',
                        fontWeight: 600,
                        fontSize: '35px',
                        color: '#3A536B',
                        paddingLeft: '63px'
                    }}>{`${formData.last_name}`}</Text>

                    <Image
                            style={{position: 'absolute', top: '-1', right: '-1', width: '433px', height: '433px'}}
                            src={window.location.origin + "/konfigurator/configurator_images/pdf_templates/car_outside/hexa_white_big.png"} // Pfad zum Bild im public-Ordner
                            // src={"/configurator_images/pdf_templates/car_outside/hexa_white_big.png"} // Pfad zum Bild im public-Ordner
                    />
                    <Image
                            style={{position: 'absolute', top: '0', right: '0', width: '430px', height: '430px'}}

                            src={window.location.origin + `/konfigurator/configurator_images/pdf_templates/car_outside/${outerColor.path}.png`} // Pfad zum Bild im public-Ordner
                            // src={`/configurator_images/pdf_templates/car_outside/${outerColor.path}.png`} // Pfad zum Bild im public-Ordner
                    />

                    <Image
                            style={{
                                position: 'absolute',
                                top: '260px',
                                right: '220px',
                                width: '150px',
                                height: '168px'
                            }}
                            src={window.location.origin + "/konfigurator/configurator_images/pdf_templates/car_outside/hexa_white.png"} // Pfad zum Bild im public-Ordner
                            // src="/configurator_images/pdf_templates/car_outside/hexa_white.png" // Pfad zum Bild im public-Ordner
                    />

                    <Image
                            style={{position: 'absolute', top: '70px', right: '380px', width: '150px', height: '168px'}}
                            src={window.location.origin + "/konfigurator/configurator_images/pdf_templates/car_outside/hexa_white.png"} // Pfad zum Bild im public-Ordner
                            // src="/configurator_images/pdf_templates/car_outside/hexa_white.png" // Pfad zum Bild im public-Ordner
                    />

                    <Image
                            style={{
                                position: 'absolute',
                                top: '261px',
                                right: '221px',
                                width: '148px',
                                height: '166px'
                            }}
                            src={window.location.origin + `/konfigurator/configurator_images/pdf_templates/car_inside/${lengthType}/cam1_${innerVersion.version}_${innerColor.path}.png`}
                            // src={`/configurator_images/pdf_templates/car_inside/${lengthType}/cam1_${innerVersion.version}_${innerColor.path}.png`}
                    />
                    <Image
                            style={{position: 'absolute', top: '71px', right: '381px', width: '148px', height: '166px'}}
                            src={window.location.origin + `/konfigurator/configurator_images/pdf_templates/car_inside/${lengthType}/cam2_${innerVersion.version}_${innerColor.path}.png`}
                            // src={`/configurator_images/pdf_templates/car_inside/${lengthType}/cam2_${innerVersion.version}_${innerColor.path}.png`}
                    />


                    <Image
                            style={{position: 'absolute', top: '25px', right: '25px', width: '120px', height: '134px'}}
                            src={window.location.origin + '/konfigurator/configurator_images/pdf_templates/p1_pricetag.png'}
                            // src="/configurator_images/pdf_templates/p1_pricetag.png"
                    />
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '12%',
                        fontWeight: 600,
                        letterSpacing: '1px',
                        fontSize: '12px',
                        color: '#3A536B',
                        right: '8%',
                    }}>{`${yourPrice}`}€*</Text>
                    <Image
                            style={{position: 'absolute', zIndex: -2, top: 0, width: '100%', height: '100%'}}
                            src={window.location.origin + '/konfigurator/configurator_images/pdf_templates/p1_template.jpg'}
                            // src={'/configurator_images/pdf_templates/p1_template.jpg'}
                    />


                </Page>
                <Page size="A4" style={{position: 'relative'}}>


                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '33%',
                        fontWeight: 600,
                        letterSpacing: '1px',
                        fontSize: '12px',
                        color: '#FFFFFF',
                        right: '13%',
                    }}>{`${yourPrice}`}€*</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        fontWeight: 800,
                        position: 'absolute',
                        top: '200px',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px'
                    }}>Dein persönliches Angebot</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '200px',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '250px'
                    }}>{`${currentDate}`}</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '250px',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px'
                    }}>{`Hallo ${formData.first_name} ${formData.last_name},`}</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '305px',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px'
                    }}>wir freuen uns, dass wir dein Interesse für einen VanChanger</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '320px',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px'
                    }}>wecken konnten. Dieses Angebot enthält deine persönliche</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '335px',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px'
                    }}>Konfiguration und ist 14 Tage ab Datum gültig.</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '375px',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px'
                    }}>Untenstehend findest Du alle Produktdetails zu</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '390px',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px'
                    }}>Deinem individuell konfigurierten Vanchanger.</Text>
                    <Text style={{
                        fontFamily: 'Inter',
                        position: 'absolute',
                        top: '450px',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px'
                    }}>Dein VanChanger Team</Text>


                    <View style={{
                        position: 'absolute',
                        top: '550px',
                        width: '100%',
                    }}>
                        <Text style={{
                            backgroundColor: '#3A536B',
                            color: '#FFFFFF',
                            fontFamily: 'Inter',
                            fontSize: '12px',
                            paddingLeft: '10%',
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            width: '80%',
                        }}>Technische Daten im Überblick</Text>
                        <Text style={{
                            backgroundColor: '#EA7C64',
                            color: '#FFFFFF',
                            fontFamily: 'Inter',
                            fontSize: '12px',
                            paddingLeft: '60px',
                            paddingTop: '5px',
                            paddingBottom: '5px',
                            width: '80%',
                        }}>Fahrzeugdaten</Text>
                        <View style={{
                            fontFamily: 'Inter',
                            fontSize: '12px',
                            color: '#3A536B',
                            left: '57px',
                            paddingTop: '5px',
                            paddingBottom: '10px',
                            paddingLeft: '5px'
                        }}>

                            {outsideConfig.pdf_info.map((item, index) => (
                                    <Text
                                            style={{
                                                paddingTop: '5px',
                                                justifyContent: 'space-between',
                                            }}
                                            key={index}
                                    >
                                        &#x2022; {Object.keys(item)[0]}: {Object.values(item)[0]}
                                    </Text>

                            ))}
                            <Text style={{paddingTop: '5px',}}>&#x2022; Außenfarbe: {current.outside_color}</Text>
                        </View>


                    </View>
                    <Image
                            style={{position: 'absolute', zIndex: -1, top: 0, width: '100%', height: '100%'}}
                            src={window.location.origin + '/konfigurator/configurator_images/pdf_templates/p2_template.jpg'}/>
                    // src="/configurator_images/pdf_templates/p2_template.jpg"


                </Page>
                <Page size="A4" style={{position: 'relative', paddingBottom: '25px', paddingTop: '25px'}}>
                    <Text style={{
                        backgroundColor: '#EA7C64',
                        color: '#FFFFFF',
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        paddingLeft: '60px',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        width: '80%',
                    }}>Grundausstattung: {current.package}</Text>
                    <View style={{
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px',
                        paddingTop: '5px',
                        paddingBottom: '10px',
                        paddingLeft: '5px',
                        width: '70%'
                    }}>

                        {carPackage[0].info.map((item, index) => (
                                <View key={index} style={{paddingTop: '5px'}}>
                                    <Text
                                            style={{
                                                justifyContent: 'space-between',
                                            }}
                                    >
                                        &#x2022; {item.item}
                                    </Text>

                                    {item.info && (
                                            <Text
                                                    style={{
                                                        fontSize: '9px', // Smaller font size
                                                        paddingLeft: '10px',
                                                        paddingTop: '5px',
                                                        color: 'gray',    // Optional: To differentiate the info text color
                                                    }}
                                            >
                                                {Array.isArray(item.info) ? item.info.join(', ') : item.info}
                                            </Text>
                                    )}
                                </View>
                        ))}
                    </View>
                    <Text style={{
                        backgroundColor: '#EA7C64',
                        color: '#FFFFFF',
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        paddingLeft: '60px',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        width: '80%',
                    }}>Grundausstattung: {current.inside_version}</Text>
                    <View style={{
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px',
                        paddingTop: '5px',
                        paddingBottom: '10px',
                        paddingLeft: '5px',
                        width: '70%'
                    }}>

                        {currentInsideVersion.info.map((item, index) => (
                                <View key={index} style={{paddingTop: '5px'}}>
                                    <Text
                                            style={{
                                                justifyContent: 'space-between',
                                            }}
                                    >
                                        &#x2022; {item.item}
                                    </Text>

                                    {item.info && (
                                            <Text
                                                    style={{
                                                        fontSize: '9px', // Smaller font size
                                                        paddingLeft: '10px',
                                                        paddingTop: '5px',
                                                        color: 'gray',    // Optional: To differentiate the info text color
                                                    }}
                                            >
                                                {Array.isArray(item.info) ? item.info.join(', ') : item.info}
                                            </Text>
                                    )}
                                </View>
                        ))}

                        {currentInsideVersion.name === "Basic Camper" && current.modules.length > 0 ? (
                                current.modules.map((moduleName: string) => {
                                    // Find the module details from config
                                    const module = config.modules.find(t => t.name === moduleName);

                                    // Check if the module exists
                                    if (!module) return null; // Skip if the module is not found

                                    return (
                                            <View key={module.name} style={{paddingTop: '5px'}}>
                                                <Text>
                                                    &#x2022; {module.name}
                                                </Text>

                                            </View>
                                    );
                                })
                        ) : (
                                current.inside_version === "Basic Camper" && (
                                        <Text
                                                style={{
                                                    paddingTop: '5px',
                                                }}
                                        >&#x2022; keine zusätzlichen Module ausgewählt</Text>
                                )
                        )}

                        <Text
                                style={{
                                    paddingTop: '5px',
                                }}
                        >
                            &#x2022; Innenraumfarbe: {innerColor.modulColor}
                        </Text>
                        <Text
                                style={{
                                    paddingTop: '5px',
                                }}
                        >
                            &#x2022; Polsterfarbe: {innerColor.fabricColorName}
                        </Text>
                        {current.seats > 0 && (
                                <Text
                                        style={{
                                            paddingTop: '5px',
                                        }}
                                >
                                    &#x2022; Gewählte Anzahl Sitze: {current.seats}
                                </Text>
                        )}
                    </View>
                    <Text style={{
                        backgroundColor: '#EA7C64',
                        color: '#FFFFFF',
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        paddingLeft: '60px',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        width: '80%',
                    }}>Technikpaket: {current.tech_package}</Text>
                    <View style={{
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px',
                        paddingTop: '5px',
                        paddingBottom: '10px',
                        paddingLeft: '5px',
                        width: '70%'
                    }}>
                        {techPackage.info.map((item, index) => (
                                <View key={index} style={{paddingTop: '5px'}}>
                                    <Text
                                            style={{
                                                justifyContent: 'space-between',
                                            }}
                                    >
                                        &#x2022; {item.item}
                                    </Text>
                                </View>
                        ))}
                    </View>
                    <Text style={{
                        backgroundColor: '#EA7C64',
                        color: '#FFFFFF',
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        paddingLeft: '60px',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        width: '80%',
                    }}>Optionale Technikfeatures</Text>
                    <View style={{
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px',
                        paddingTop: '5px',
                        paddingBottom: '10px',
                        paddingLeft: '5px',
                        width: '70%'
                    }}>

                        {current.tech_optional.length > 0 ? (
                                current.tech_optional.map((i: string) => (
                                        <Text key={i} style={{paddingTop: '5px'}}>
                                            &#x2022; {i}
                                        </Text>
                                ))
                        ) : (
                                <Text>&#x2022; keine optionalen Technikfeatures ausgewählt</Text>
                        )}
                    </View>
                    <Text style={{
                        backgroundColor: '#EA7C64',
                        color: '#FFFFFF',
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        paddingLeft: '60px',
                        paddingTop: '5px',
                        paddingBottom: '5px',
                        width: '80%',
                    }}>Gadgets</Text>
                    <View style={{
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        color: '#3A536B',
                        left: '57px',
                        paddingTop: '5px',
                        paddingBottom: '10px',
                        paddingLeft: '5px',
                        width: '70%'
                    }}>

                        {current.gadgets.length > 0 ? (
                                current.gadgets.map((gadgetName: string) => {
                                    // Find the gadget details from config
                                    const gadget = config.Gagets.find(t => t.name === gadgetName);

                                    // Check if gadget is found
                                    if (!gadget) {
                                        return null; // Skip rendering if gadget is not found
                                    }

                                    // Get the quantity from current state
                                    const quantity = current[`amount-${gadget.name}`] || 0;

                                    // Check min and max amounts if defined
                                    const minAmount = gadget.minAmount || 1; // Default to 1 if not defined
                                    const maxAmount = gadget.maxAmount || Infinity; // Default to Infinity if not defined

                                    return (
                                            <View key={gadget.name} style={{paddingTop: '5px'}}>
                                                <Text>
                                                    &#x2022; {gadget.name}
                                                </Text>
                                                {quantity > 0 && (
                                                        <Text style={{
                                                            fontSize: '9px',
                                                            paddingLeft: '10px',
                                                            color: 'gray'
                                                        }}>
                                                            Menge: {quantity}
                                                            {quantity < minAmount ?
                                                                    `(Mindestanzahl: ${minAmount})` :
                                                                    quantity > maxAmount ?
                                                                            `(Maximalanzahl: ${maxAmount})` :
                                                                            ''
                                                            }
                                                        </Text>
                                                )}
                                            </View>
                                    );
                                })
                        ) : (
                                <Text>&#x2022; keine Gadgets ausgewählt</Text>
                        )}


                    </View>
                </Page>
            </Document>
    );

    return (
            <div className={'form-container'}>
                <form className={"form"} onSubmit={(e) => saveData(e, formData, url.href)}>
                    <input
                            className={"form-field"}
                            type={"text"}
                            name={"first_name"}
                            placeholder={"Vorname"}
                            value={formData.first_name}
                            onChange={(event) => handleChange(event, setFormData)} // Nur 2 Argumente übergeben
                            required={true}
                    />
                    <input
                            className={"form-field"}
                            type={"text"}
                            name={"last_name"}
                            placeholder={"Nachname"}
                            value={formData.last_name}
                            onChange={(event) => handleChange(event, setFormData)} // Nur 2 Argumente übergeben
                            required={true}
                    />
                    <input
                            className={"form-field"}
                            type={"email"}
                            name={"email"}
                            placeholder={"E-Mail"}
                            value={formData.email}
                            onChange={(event) => handleChange(event, setFormData)} // Nur 2 Argumente übergeben
                            required={true}
                    />
                    <input
                            className={"form-field"}
                            type={"tel"}
                            name={"tel"}
                            placeholder={"Telefon"}
                            value={formData.tel}
                            onChange={(event) => handleChange(event, setFormData)} // Nur 2 Argumente übergeben
                            required={true}
                    />

                    <div className="form-checkbox form-field">
                        <input type="checkbox" required={true} id={"acceptTerms"}/>
                        <label htmlFor="acceptTerms">* Ich stimme der Verarbeitung meiner persönlichen Daten gemäß
                            des <a
                                    className={"link-datenschutz"}
                                    target={"_blank"}
                                    href="https://vanchanger.de/html/datenschutz.html">Datenschutzes</a> zu.</label>
                    </div>

                    <button className={`config-button form-submit ${isDisabled ? '' : 'no-display'}`} type={"submit"}>
                        Konfiguration anfragen
                    </button>
                    <PDFDownloadLink
                            className={`config-button form-submit pdf-download flex ${isDisabled ? 'no-display' : ''}`}
                            // className={`config-button form-submit pdf-download flex`}

                            document={<MyDocument/>}
                            fileName="VanChanger_Angebot.pdf"
                            onClick={pdf_download}

                            // type={"submit"}
                    >
                        Angebot downloaden
                    </PDFDownloadLink>


                </form>

            </div>
    );


}

export default Pdf;

